import {
  IonHeader,
  IonPage,
  IonRefresher,
  IonRefresherContent,
  type RefresherEventDetail,
  useIonViewWillEnter,
} from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useQueryClient } from "@tanstack/react-query";
import { Content } from "@/components/content";
import { OrganizationDropdown } from "@/components/molecules/organization/organization-dropdown";
import { CompletedShiftsView } from "@/components/molecules/shift/completed-shifts-view";
import { Toolbar } from "@/components/toolbar";

/**
 * The standalone completed-shifts destination, kept because Vandaag links straight to it. All of
 * its content now lives in CompletedShiftsView, which the Afgerond tab in Diensten renders too —
 * one concept, one design, one codepath.
 */
export function CompletedShiftsReworkPage() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const refetchAll = () =>
    Promise.all([
      queryClient.refetchQueries({ queryKey: ["shifts"] }),
      queryClient.refetchQueries({ queryKey: ["expense-claim-file"] }),
    ]);

  const handleRefresh = async (event: CustomEvent<RefresherEventDetail>) => {
    await refetchAll();
    event.detail.complete();
  };

  useIonViewWillEnter(() => {
    void refetchAll();
  });

  return (
    <IonPage>
      <IonHeader>
        <Toolbar className="ion-no-border plt-desktop:sm:ion-px-[max(calc(calc(100vw-640px)/2),theme(spacing.4))]">
          <div className="flex items-center gap-3">
            <h1 className="text-2xl font-semibold leading-[1.2] text-txt-primary">
              {t("routes:upcoming-shifts.completed-tab")}
            </h1>
            <OrganizationDropdown />
          </div>
        </Toolbar>
      </IonHeader>
      <Content scrollUnderChrome>
        <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
          <IonRefresherContent refreshingSpinner="circles" />
        </IonRefresher>
        <CompletedShiftsView />
      </Content>
    </IonPage>
  );
}
